<template>
  <section class="download-app">
    <div class="links">
      <a>
        <img src="../assets/appleStore.png" />
      </a>
      <a>
        <img src="../assets/googlePlay.png" />
      </a>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.download-app {
  padding: 25px;
  position: fixed;
  bottom: 10px;
  left: 0;
  width: 20.7777%;
}

.download-app p {
  color: #fff;
  font-size: calc(16px + (18 - 16) * ((100vw - 300px) / (1600 - 300)));
}

.download-app hr {
  margin: 15px 0px 5px;
  border: 1px solid #ff222a;
  width: 195px;
}

.download-app h1 {
  font-size: calc(18px + (36 - 18) * ((100vw - 300px) / (1600 - 300)));
  color: #fff;
}

.download-app .links {
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
}

.download-app .links a {
  width: 40%;
  margin-right: 2%;
}

.download-app .links a img {
  width: 100%;
}
</style>